export default __webpack_public_path__ + "static/company-mobile-app-a41d178989e92ff30239faf67b35e016.png";